import React from "react";
import CountUp from 'react-countup';
import { withRender } from 'utils/render';

import {
  BannerText,
  BannerPhone,
  BannerTextMobile,
  BannerPhoneMobile,
} from 'assets';
import { CoupleCount, ShopCount } from 'variables';
import {
  JumbotronWrapper,
  ImageBanner,
  Banner,
  LineBreak,
  Text,
} from './style';

const Jumbotron: React.FC = _ => {
  return (
    <JumbotronWrapper>
      <ImageBanner>
        <Banner
          src={BannerText}
          alt="홈1"
          bannerType="desktop"
          style={{
            maxWidth: '620px',
            marginRight: '30px',
            marginTop: '-120px',
          }}
        />
        <Banner
          src={BannerPhone}
          alt="홈2"
          bannerType="desktop"
          style={{
            maxWidth: '270px',
          }}
        />
        <Banner
          src={BannerPhoneMobile}
          alt="홈모바일1"
          bannerType="mobile"
          style={{
            maxWidth: '62%',
            marginBottom: '20px',
          }}
        />
        <Banner
          src={BannerTextMobile}
          alt="홈모바일2"
          bannerType="mobile"
          style={{
            maxWidth: '82%',
            marginBottom: '30px',
          }}
        />
      </ImageBanner>
      <Text>
        대한민국 <CountUp end={CoupleCount} duration={1.5} separator={','} />만 커플, <CountUp end={ShopCount} duration={1.5} separator={','} />개 제휴점 사장님과<LineBreak />
        함께 매일매일 성장하고 있습니다.
      </Text>
    </JumbotronWrapper>
  );
}

export default withRender(Jumbotron);
